import React from 'react';
import {connect} from 'react-redux';
import {
	findCollaborators,
	getSharingDetailsLv2Popup,
	getSharingDetailsPopup
} from '../../../actions/sharingDetailsActions';
import { findContacts} from "../../../actions/contactActions";
import {getSelectedContactsGroup} from '../../../actions/contactsGroupItemActions';
import Icon from "../icon";
import './index.css';

class SharingPreview extends React.Component {

    constructor(props){
        super(props);

        this.handler = this.handler.bind(this);
        this.warningHandler = this.warningHandler.bind(this);
    }

	handler(){

		/*if (
			this.props.sharingDetailsPopup[1] === "contact_details"
			|| this.props.sharingDetailsPopup[1] === "gmail_contact_details"
		) {
			e.stopPropagation();
		}*/

		if (this.props.sharingDetailsPopup.length > 0) {

			if(this.props.profile.status.includes('invited') || (this.props.status === "SHARED_WITH_ME" && this.props.permission !== "CAN_SHARE")){
				//this.props.getSharingDetailsPopup([true, "view_collaborators"]);
			} else {
				if(document.querySelector('.slide.new-contact-details-popup')){

					if(this.props.sharingDetailsPopup[1] === "gmail_contact_details"){
						document.querySelector('.slide.new-contact-details-popup').style.left = '-688px';
					} else {
						document.querySelector('.slide.new-contact-details-popup').style.left = '-768px';
					}


					/*
					* Because add_collaborator_popup content is already loaded thus, it didn't trigger its componentDidMount, so we need to trigger the collaborators list manually
					* */

					this.props.setFindCollaborators(this.props.labelId, this.props.collaboratorsPageSize);
				}
			}

		} else {
			if(this.props.profile.status.includes('invited') || (this.props.status === "SHARED_WITH_ME" && this.props.permission !== "CAN_SHARE")){
				this.props.getSharingDetailsPopup([true, "view_collaborators"]);
			} else {
				this.props.getSharingDetailsPopup([true, "add_user"]);
			}
		}

	}

    warningHandler(e,checkStatus){
        e.stopPropagation();
        if(checkStatus.partiallyShared){
            this.props.setFindContacts(this.props.labelId, this.props.contactsPageSize)

            this.props.getSelectedContactsGroup({
                'id' : this.props.labelId
            });

            this.props.getSharingDetailsPopup([true, "add_user"]);
        } else if(this.props.permission === 'OWNER' || this.props.permission === 'CAN_SHARE'){
        let cTarget = e.currentTarget;
        this.props.getSharingDetailsLv2Popup([true, "user_collaboratorStatuses", "invitationPending", cTarget.dataset.email, cTarget.dataset.collaboratorType]);
    }
}

    renderIcon = (statusOfUser) => {


        if (statusOfUser.statuses.upgradeNow){
            return (
            <div
                className={`collaborator-status warning`}
                data-email={statusOfUser.email}
                data-collaborator-type={statusOfUser.type}
            >
                <Icon name="level-up"/>
            </div>
            )
        } else if (statusOfUser.statuses.invitationPending){
            return (
            <div
                className={`collaborator-status warning`}
                data-email={statusOfUser.email}
                data-collaborator-type={statusOfUser.type}
                onClick={this.warningHandler}
            >
                <Icon name="warning"/>
            </div>
            )
        } else if (statusOfUser.statuses.revoked){
            return (
            <div
                className={`collaborator-status warning`}
                data-email={statusOfUser.email}
                data-collaborator-type={statusOfUser.type}

            >
                <Icon name="times-circle" />
            </div>
            )
        } else if (statusOfUser.statuses.suspended){
            return (
            <div
                className={`collaborator-status warning`}
                data-email={statusOfUser.email}
                data-collaborator-type={statusOfUser.type}
            >
                <Icon name="minus-circle" />
            </div>
            )
        } else if (statusOfUser.statuses.overQuota){
            return (
            <div
                className={`collaborator-status warning`}
                data-email={statusOfUser.email}
                data-collaborator-type={statusOfUser.type}
            >
                <Icon name="minus-circle" />
            </div>
            )
        } else if (statusOfUser.statuses.banned){
            return (
            <div
                className={`collaborator-status warning`}
                data-email={statusOfUser.email}
                data-collaborator-type={statusOfUser.type}
            >
                <Icon name="gavel" />
            </div>
            )
        } else if (statusOfUser.statuses.deleted){
            return (
            <div
                className={`collaborator-status warning`}
                data-email={statusOfUser.email}
                data-collaborator-type={statusOfUser.type}
            >
                <Icon name="user-times" />
            </div>
            )
        } else if (statusOfUser.statuses.licenseLimitReached){
            return (
            <div
                className={`collaborator-status warning`}
                data-email={statusOfUser.email}
                data-collaborator-type={statusOfUser.type}
            >
                <Icon name="user-times" />
        </div>
            )
        } else if (statusOfUser.statuses.invitationWarning){
            return (
            <div
                className={`collaborator-status warning`}
                data-email={statusOfUser.email}
                data-collaborator-type={statusOfUser.type}
            >
                <Icon name="warning" />
            </div>
            )
        } else if (statusOfUser.statuses.partiallyShared){
            return (
            <div
                className={`collaborator-status warning`}
                data-email={statusOfUser.email}
                data-collaborator-type={statusOfUser.type}
            >
                <Icon name="warning"/>
            </div>
            )
        } else if (statusOfUser.statuses.sharingLimitReached){
			return (
				<div
					className={`collaborator-status warning`}
					data-email={statusOfUser.email}
					data-collaborator-type={statusOfUser.type}
				>
					<Icon name="minus-circle" />
				</div>
			)
        } else if (statusOfUser.statuses.unknown){
            return (
            <div
                className={`collaborator-status warning`}
                data-email={statusOfUser.email}
                data-collaborator-type={statusOfUser.type}
            >
                <Icon name="question-circle-o"/>
            </div>
            )
        } else if (statusOfUser.statuses.contactLimitReached){
		    return (
			    <div
				    className={`collaborator-status warning`}
				    data-email={statusOfUser.email}
				    data-collaborator-type={statusOfUser.type}
			    >
				    <Icon name="level-up"/>
			    </div>
		    )
	    } else {
	        return (
		        <div className={`collaborator-status valid`}>
			        <Icon name="check"/>
		        </div>
	        )
        }

    };

	render() {
		return (
			<div className="d-flex align-items-center sharing-preview">
				<div className="flex-grow-1 shared-with d-flex align-items-center justify-content-end">
					<div className="avatars">
						{
							this.props.collaborators.slice( this.props.status !== 'NOT_SHARED' ? 0 : 1, 3).map( (collaborator, index) => {
                                return (
                                    <div key={index} onClick={this.handler}>
                                        {
                                            collaborator.photoBase64String
                                            ?
                                                <img src={'data:image/png;base64,' + collaborator.photoBase64String} alt=""/>
                                            :
                                                <img src={collaborator.pictureUrl} alt=""/>
                                        }
                                        {this.renderIcon(collaborator)}
                                    </div>
                                )
                            })
						}
					</div>
					{
						this.props.sharingNumber > 2
							?
							<div className="ml-2" onClick={this.handler}>+ {(this.props.sharingNumber - 2)}</div>
							:
							''
					}
				</div>
			</div>
		)
	}
}

const mapStateToProps = (state) => {
    return {
        profile: state.profileReducer.getProfile,
        isSyncing: state.syncStatusReducer.isSyncing,
	    sharingDetailsPopup: state.sharingDetailsReducer.getSharingDetailsPopup
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
	    setFindCollaborators : (selectedLabelId, pageSize) => {
		    dispatch(findCollaborators(selectedLabelId, pageSize))
	    },
        getSharingDetailsPopup : (array) => {
            dispatch(getSharingDetailsPopup(array))
        },
        getSharingDetailsLv2Popup : (array) => {
            dispatch(getSharingDetailsLv2Popup(array))
        },
        getSelectedContactsGroup : (object) => {
            dispatch(getSelectedContactsGroup(object))
        },
        setFindContacts : (contactsGroupId, pageSize) => {
            dispatch(findContacts(contactsGroupId, pageSize))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SharingPreview);
